export default function BackCircle({ className, backgroundColor }) {
    return (
      <svg className={className} width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
          <circle cx="16" cy="16" r="16" fill={backgroundColor} />
          <path d="M21.0391 15.6562H12.1155"
                stroke="#203B3F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round" />
          <path d="M15.8086 11.8395L11.3128 15.6561L15.8086 19.4863"
                stroke="#203B3F"
                strokeWidth="1.5"
                strokeMiterlimit="10"
                strokeLinecap="round" />
      </svg>
    )
}
